export default __webpack_public_path__ + "static/media/search.8ba2222d.svg";